import React from "react";
import { ListCollapse, Inbox, CircleSlash } from "lucide-react";
import { WorkspaceTask } from "./types";
import { ActionStreamEntry } from "./ActionStreamEntry";

interface ActionStreamProps {
  tasks: WorkspaceTask[];
  onRetry: (id: string) => void;
  onReport: (id: string) => void;
  isAr?: boolean;
}

export const ActionStream: React.FC<ActionStreamProps> = ({
  tasks,
  onRetry,
  onReport,
  isAr = false,
}) => {
  return (
    <div className="flex-1 flex flex-col min-h-0 min-w-0">
      
      {/* Scrollable feed section */}
      <div className="flex-1 overflow-y-auto pr-1 space-y-4 max-h-[640px] scrollbar-thin">
        {tasks.length === 0 ? (
          /* Premium GCC design empty state placeholder */
          <div className="flex flex-col items-center justify-center py-16 px-4 bg-white rounded-2xl border border-slate-200/60 text-center space-y-4">
            <div className="p-4 bg-slate-50 border border-slate-100 rounded-full text-slate-400">
              <Inbox size={28} />
            </div>
            <div className="space-y-1 max-w-sm">
              <h5 className="font-extrabold text-slate-900 text-sm">
                {isAr ? "لا توجد مهام مطابقة للمرشحات" : "No Active Workspace Commands"}
              </h5>
              <p className="text-xs text-slate-500 font-semibold leading-relaxed">
                {isAr 
                  ? "قم بصياغة طلب جديد أو تصفح مكتبة النماذج لتشغيل مهام التدقيق والامتثال القانوني المستقلة." 
                  : "Compose a manual command in the bottom controller, or pick pre-packaged filters from the Prompt Library to start."}
              </p>
            </div>
          </div>
        ) : (
          tasks.map((task) => (
            <ActionStreamEntry
              key={task.id}
              task={task}
              isAr={isAr}
              onRetry={onRetry}
              onReport={onReport}
            />
          ))
        )}
      </div>

    </div>
  );
};
